// /tools — ดัชนีเครื่องมือช่วยตัดสินใจ
import { createFileRoute, Link } from "@tanstack/react-router";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";
import { organizationSchema, speakableSchema } from "@/lib/aeo";
import { consolidateGraph } from "@/lib/schema-graph";

const SITE = "https://nyclanguageinstitute.com";
const PATH = "/tools";
const TITLE = "เครื่องมือช่วยตัดสินใจเรื่องเอกสาร — เช็กลิสต์ ระยะเวลา และการเปรียบเทียบ";
const DESC =
  "รวมเครื่องมือช่วยวางแผนงานเอกสาร: ตัวช่วยเลือกชุดเอกสารตามประเภทเคส ตัวประเมินระยะเวลาแต่ละขั้น และตารางเปรียบเทียบ Notary แปลรับรอง NAATI และ MFA/Apostille";

const TOOLS = [
  {
    to: "/tools/document-advisor" as const,
    title: "ตัวช่วยเลือกชุดเอกสาร",
    desc: "บอกวัตถุประสงค์และประเทศปลายทาง แล้วดูรายการเอกสารที่ต้องเตรียมพร้อมลำดับการรับรอง",
  },
  {
    to: "/tools/timeline" as const,
    title: "ตัวประเมินระยะเวลาและลำดับขั้น",
    desc: "ประเมินช่วงวันทำการโดยประมาณของแต่ละขั้นตอน ตั้งแต่ขอเอกสารจนถึงจัดส่ง",
  },
  {
    to: "/compare/service-types" as const,
    title: "เปรียบเทียบ Notary / แปลรับรอง / NAATI / MFA-Apostille",
    desc: "ตารางเทียบว่าแต่ละบริการทำอะไร ใช้เมื่อไร ใช้เวลาเท่าไร และต้องเตรียมอะไร",
  },
];

export const Route = createFileRoute("/tools/")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, PATH, "th") },
      { name: "description", content: ctaDesc(DESC, PATH, "th") },
      { property: "og:title", content: ctaTitle(TITLE, PATH, "th") },
      { property: "og:description", content: ctaDesc(DESC, PATH, "th") },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: canonicalAndHreflang(PATH),
    scripts: [consolidateGraph([organizationSchema(), speakableSchema([".aeo-speakable", "h1", "h2"])])],
  }),
  component: ToolsIndex,
});

function ToolsIndex() {
  return (
    <main className="mx-auto w-full max-w-3xl px-4 py-10">
      <h1 className="text-3xl font-bold tracking-tight">เครื่องมือช่วยตัดสินใจเรื่องเอกสาร</h1>
      <p className="aeo-speakable mt-3 text-muted-foreground">
        เครื่องมือทั้งสามช่วยให้คุณเห็นภาพรวมก่อนเริ่มงานจริง ว่าต้องเตรียมเอกสารอะไร
        ต้องผ่านกี่หน่วยงาน และใช้เวลาโดยประมาณเท่าไร
      </p>
      <ul className="mt-8 space-y-4">
        {TOOLS.map((t) => (
          <li key={t.to}>
            <Link to={t.to} className="block rounded-xl border border-border bg-card p-5 transition hover:border-primary">
              <h2 className="text-lg font-semibold">{t.title}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{t.desc}</p>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
}
